import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "tw w-full flex justify-between list-content at-list-item",
  color: "gray"
};
const _hoisted_2 = {
  class: "w-full ml-2 flex justify-between"
};
const _hoisted_3 = {
  class: "custom-tooltip"
};
const _hoisted_4 = {
  class: "tooltip-content-wrapper"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  key: 2
};
const _hoisted_9 = {
  key: 0
};
import { onMounted, reactive } from "vue";
import { useEmbeddedReportStore } from "./useEmbeddedReportStore.js";
import ShareDashboard from "./ShareDashboard.vue";
import DeleteDashboardDialog from "./DeleteDashboardDialog.vue";
export default {
  __name: 'LeftNavBar',
  props: {
    alerts: {
      type: Object,
      required: false
    },
    leftNavbarReportOption: {
      type: Array,
      required: false
    },
    embeddedReportKeys: {
      type: Object,
      required: false
    },
    generic: {
      type: Boolean,
      required: false
    },
    routeService: {
      type: Object,
      required: false
    },
    canUseEditor: {
      type: Boolean,
      required: false
    },
    tracking: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: true
    },
    reportState: {
      type: Object,
      required: true
    }
  },
  emits: ["openDashboard", "editDashboard", "shareDashboard", "copyDashboard"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const leftNavBarState = reactive({
      disabled: false,
      customReportList: [],
      confirmDelete: false,
      shareDashboard: false,
      shareDashboardId: undefined,
      deleteDashboard: false,
      deleteDashboardId: null,
      dialog: false,
      me: {}
    });
    const emit = __emit;
    const embeddedReportStore = useEmbeddedReportStore();
    onMounted(async () => {
      leftNavBarState.me = await props.userService.me();
    });
    const openDashboard = option => {
      if (option.embedded || option.isEmbeddedSharedReport || option.isShared) {
        embeddedReportStore.setHighlightedItem(option.id);
        emit("openDashboard", option);
        return;
      }
      if (props.generic) {
        props.routeService.go("reports.generic", {
          id: option,
          ...dateRangeId
        });
        return;
      }
      props.routeService.go(`reports.${option}`, {
        dateRangeId
      });
    };
    const closeOpps = () => {
      leftNavBarState.shareDashboardId = undefined;
    };
    const editDashboard = async option => {
      embeddedReportStore.setHighlightedItem(option.id);
      emit("editDashboard", option.id);
    };
    const deleteDashboard = option => {
      leftNavBarState.deleteDashboard = true;
      embeddedReportStore.deleteDashboardDialog = true;
      leftNavBarState.deleteDashboardId = option.id;
    };
    const shareDashboardToOthers = option => {
      leftNavBarState.shareDashboard = true;
      embeddedReportStore.shareDashboardDialog = true;
      // check of option is string or object
      if (option && typeof option === "string") {
        leftNavBarState.shareDashboardId = option;
      }
    };
    const copyDashboard = async option => {
      emit("copyDashboard", option.id);
    };
    return (_ctx, _cache) => {
      const _component_v_list_item_title = _resolveComponent("v-list-item-title");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_tooltip = _resolveComponent("v-tooltip");
      const _component_v_btn = _resolveComponent("v-btn");
      return _openBlock(), _createElementBlock(_Fragment, null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.leftNavbarReportOption.options, (option, ids) => {
        return _openBlock(), _createElementBlock("div", {
          key: ids,
          class: "w-full flex justify-between"
        }, [option && option.label ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          variant: "text",
          class: _normalizeClass(["w-full flex justify-between", {
            'll-nav-current-y': _unref(embeddedReportStore).highlightedDashboardId === option.id
          }]),
          "aria-current": _unref(embeddedReportStore).highlightedDashboardId === option.id ? 'page' : undefined,
          onClick: _withModifiers($event => openDashboard(option), ["stop"])
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_v_list_item_title, {
            class: _normalizeClass([[option.advancedReport === true && !__props.reportState?.me?.features.reportsAdvanced ? 'text-grey' : 'text-black'], "text-md font-bold list-title w-3/5 at-report-sub-header flex-grow whitespace-nowrap overflow-hidden text-overflow-ellipsis"])
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(option.label), 1)]),
            _: 2
          }, 1032, ["class"]), _createVNode(_component_v_list_item_title, {
            class: _normalizeClass(["flex align-center justify-end text-black", [option.advancedReport === true && !__props.reportState?.me?.features.reportsAdvanced ? 'text-grey' : 'text-black']])
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [option.description ? (_openBlock(), _createBlock(_component_v_tooltip, {
              key: 0,
              location: "top"
            }, {
              activator: _withCtx(({
                props
              }) => [_createElementVNode("span", _mergeProps({
                ref_for: true
              }, props, {
                class: "ml-2 at-info"
              }), [_createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("mdi-information-outline", -1)]))]),
                _: 1
              })], 16)]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", null, [_createTextVNode(_toDisplayString(option.description) + " ", 1), option.isShared ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Shared By: " + _toDisplayString(option.owner), 1)) : _createCommentVNode("", true)])])]),
              _: 2
            }, 1024)) : _createCommentVNode("", true)]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_v_tooltip, {
              text: "Share",
              location: "top",
              "max-width": "80"
            }, {
              activator: _withCtx(({
                props
              }) => [_createVNode(_component_v_icon, _mergeProps({
                ref_for: true
              }, props, {
                onClick: _withModifiers($event => shareDashboardToOthers(option.id), ["stop"]),
                class: "ml-2 at-share"
              }), {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("mdi-share-variant", -1)]))]),
                _: 1
              }, 16, ["onClick"])]),
              _: 2
            }, 1024)], 512), [[_vShow, option.embeddedCustomReport && !option.isShared && __props.reportState?.me?.features.luzmoTransition]]), props.embeddedReportKeys?.canUseEditor ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_v_tooltip, {
              text: "Open",
              location: "top",
              "max-width": "80"
            }, {
              activator: _withCtx(({
                props
              }) => [_createVNode(_component_v_icon, _mergeProps({
                ref_for: true
              }, props, {
                onClick: _withModifiers($event => openDashboard(option), ["stop"]),
                class: "ml-1 at-open"
              }), {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("mdi-open-in-new", -1)]))]),
                _: 1
              }, 16, ["onClick"])]),
              _: 2
            }, 1024)])) : _createCommentVNode("", true), props.embeddedReportKeys?.canUseEditor && !option.isShared && !option.advancedReport && option.embeddedCustomReport && __props.reportState?.me?.features.luzmoTransition ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_v_tooltip, {
              text: "Edit",
              location: "top",
              "max-width": "80"
            }, {
              activator: _withCtx(({
                props
              }) => [_createVNode(_component_v_icon, _mergeProps({
                ref_for: true
              }, props, {
                onClick: _withModifiers($event => editDashboard(option), ["stop"]),
                class: "ml-1 at-edit"
              }), {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("mdi-pencil", -1)]))]),
                _: 1
              }, 16, ["onClick"])]),
              _: 2
            }, 1024)])) : _createCommentVNode("", true), option.embeddedCustomReport && option.isOwner && !option.isShared && __props.reportState?.me?.features.luzmoTransition ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_v_tooltip, {
              text: "Delete",
              "max-width": "80",
              location: "top"
            }, {
              activator: _withCtx(({
                props
              }) => [_createVNode(_component_v_icon, _mergeProps({
                ref_for: true
              }, props, {
                onClick: _withModifiers($event => deleteDashboard(option), ["stop"]),
                color: "error",
                class: "ml-1 at-delete"
              }), {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("mdi-delete", -1)]))]),
                _: 1
              }, 16, ["onClick"])]),
              _: 2
            }, 1024)])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["class"])])])]),
          _: 2
        }, 1032, ["class", "aria-current", "onClick"])) : _createCommentVNode("", true)]);
      }), 128)), _createElementVNode("template", null, [leftNavBarState.deleteDashboard ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(DeleteDashboardDialog, {
        leftNavBarState: leftNavBarState,
        alerts: __props.alerts
      }, null, 8, ["leftNavBarState", "alerts"])])) : _createCommentVNode("", true), leftNavBarState.shareDashboard ? (_openBlock(), _createBlock(ShareDashboard, {
        key: 1,
        leftNavBarState: leftNavBarState,
        onCloseDeleteDialog: _cache[0] || (_cache[0] = $event => closeOpps()),
        alerts: __props.alerts
      }, null, 8, ["leftNavBarState", "alerts"])) : _createCommentVNode("", true)])], 64);
    };
  }
};